"use client";

import { Provider } from "@rollbar/react";
import { clientConfig } from "@/rollbar";

export function RollbarProvider({ children }: { children: React.ReactNode }) {
  if (!clientConfig.accessToken) {
    return <>{children}</>;
  }

  return <Provider config={clientConfig}>{children}</Provider>;
}
